import TopNavbar from "../components/navbar/Navbar";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Sidebar from "../components/navbar/Sidebar";
import projectUsers from "../../src/assets/images/projectUsers.png";
import library from "../../src/assets/images/library.png";
import cadWhite from "../../src/assets/images/cadWhite.png";
import legacyReport from "../../src/assets/images/legacyReport.png";
import Projects from "../components/fullPageComps/Projects";
import ObjectLibrary from "../components/fullPageComps/objectLibrary";
import StaticObjectLibrary from "../components/fullPageComps/staticObjectLibrary";
import CheckLists from "../components/field/CheckLists";
import {
  SELECTED_ICON,
  updateNavigationState,
} from "../helpers/reducers/NavigationReducer";
import MaintenanceAdmin from "../components/maintenance/MaintenanceAdmin";
import CadUpload from "../components/fullPageComps/CadUpload";
import LoadingScreen from "../components/loadingScreen/LoadingScreen";
import LegacyReports from "../components/fullPageComps/LegacyReports";

const Settings = () => {
  const { selectedIcon } = useSelector((state) => state.navigationReducer);
  const { superUserDetails, userDetails, projectChangeLoading } = useSelector(
    (state) => state.globalReducer,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    //default tab to open on
    if (userDetails?.projectAdmin || superUserDetails?.admin) {
      dispatch(updateNavigationState("Users", SELECTED_ICON));
    } else if (superUserDetails?.cadTemplateUpload) {
      dispatch(updateNavigationState("CAD Upload", SELECTED_ICON));
    } else {
      dispatch(updateNavigationState("", SELECTED_ICON));
    }
  }, [
    dispatch,
    userDetails?.projectAdmin,
    superUserDetails?.admin,
    superUserDetails?.cadTemplateUpload,
  ]);

  const buttonController = (type) => {
    dispatch(
      updateNavigationState({
        value: type,
        stateName: SELECTED_ICON,
      }),
    );
  };

  return (
    <div className="projects-page">
      <TopNavbar />
      {userDetails?.projectAdmin ||
      superUserDetails?.admin ||
      superUserDetails?.cadTemplateUpload ? (
        <>
          {" "}
          <Sidebar>
            <>
              {(userDetails?.projectAdmin || superUserDetails?.admin) && (
                <li className="nav-item" style={{ marginTop: "5px" }}>
                  <button
                    type="button"
                    className="nav-link"
                    title="Projects"
                    data-bs-toggle="tooltip"
                    onClick={() => {
                      buttonController("Users");
                    }}
                  >
                    <img
                      className="sideBarIcon"
                      src={projectUsers}
                      alt="user"
                    />
                  </button>
                </li>
              )}
              {superUserDetails?.cadTemplateUpload && (
                <li className="nav-item">
                  <button
                    type="button"
                    className="nav-link"
                    title="CAD Upload"
                    data-bs-toggle="tooltip"
                    onClick={() => {
                      buttonController("CAD Upload");
                    }}
                  >
                    <img className="sideBarIcon" src={cadWhite} alt="user" />
                  </button>
                </li>
              )}
              {superUserDetails?.legacyReportAdmin && (
                <li className="nav-item">
                  <button
                    type="button"
                    className="nav-link"
                    title="Legacy Report Admin"
                    data-bs-toggle="tooltip"
                    onClick={() => {
                      buttonController("Legacy Report Admin");
                    }}
                  >
                    <img className="sideBarIcon" src={legacyReport} alt="user" />
                  </button>
                </li>
              )}
              {/* <li className="nav-item">
            <button
              type="button"
              className="nav-link nav-btn"
              title="mView+ Projects"
              data-bs-toggle="tooltip"
              onClick={() => {
                buttonController("Projects");
              }}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
            >
              <img className="sideBarIcon" src={mviewPlus} alt="user" />
            </button>
          </li> */}
              {/* <li className="nav-item">
            <button
              type="button"
              className="nav-link nav-btn"
              title="OPM"
              data-bs-toggle="tooltip"
              onClick={() => {
                buttonController("OPM");
              }}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
            >
              <img className="sideBarIcon" src={opm} alt="opm" />
            </button>
          </li> */}
              {/* TODO Need to create a super user role for access to the static library and its editing capabilities */}
              {/* <li className="nav-item">
                <button
                  type="button"
                  className="nav-link"
                  title="Static Library"
                  data-bs-toggle="tooltip"
                  onClick={() => {
                    buttonController("Static Objects");
                  }}
                >
                  <img
                    className="sideBarIcon"
                    src={library}
                    alt="Static Library"
                  />
                </button>
              </li> */}
              {/* <li className="nav-item">
            <button
              type="button"
              className="nav-link nav-btn"
              title="Checklists"
              data-bs-toggle="tooltip"
              onClick={() => {
                buttonController("ChecklistsAdmin");
              }}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
            >
              <img className="sideBarIcon" src={checklist} alt="Checklists" />
            </button>
          </li> */}
              {/* <li className="nav-item">
            <button
              type="button"
              className="nav-link nav-btn"
              title="Maintenance"
              data-bs-toggle="tooltip"
              onClick={() => {
                buttonController("MaintenanceAdmin");
              }}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
            >
              <img
                className="sideBarIcon"
                src={maintenance}
                alt="Maintenance"
              />
            </button>
          </li> */}
            </>
          </Sidebar>
          <div className="container-fluid projects-layout">
            <div className="row projects-row" style={{ height: "93vh" }}>
              <div
                className="col projects-content-col"
                style={{
                  paddingLeft: "57px",
                  paddingRight: "5px",
                }}
              >
                <div
                  className="projects-content-shell"
                  style={{
                    position: "relative",
                    margin: "2px",
                    height: "calc(100% - 4px)",
                    width: "100%",
                  }}
                >
                  {projectChangeLoading ? (
                    <LoadingScreen
                      input="Loading Project"
                      width="12"
                      height="100%"
                      marginTop="6%"
                      variant="properties"
                      subtitle="Loading project details..."
                      transparent={true}
                    />
                  ) : (
                    <>
                      {selectedIcon === "Users" ? <Projects /> : <></>}
                      {/* {selectedIcon === "Projects" ? <MviewPlusProjects /> : <></>} */}
                      {selectedIcon === "OPM" ? <ObjectLibrary /> : <></>}
                      {selectedIcon === "Static Objects" ? (
                        <StaticObjectLibrary />
                      ) : (
                        <></>
                      )}
                      {selectedIcon === "ChecklistsAdmin" ? (
                        <CheckLists />
                      ) : (
                        <></>
                      )}
                      {selectedIcon === "MaintenanceAdmin" ? (
                        <MaintenanceAdmin />
                      ) : (
                        <></>
                      )}
                      {selectedIcon === "CAD Upload" ? <CadUpload /> : <></>}
                      {selectedIcon === "Legacy Report Admin" ? <LegacyReports /> : <></>}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="alert alert-danger" role="alert">
          You do not have permission to view this page. Please contact your
          administrator.
        </div>
      )}
    </div>
  );
};

export default Settings;
